require('../../modules/es6.object.keys');
module.exports = require('../../modules/$.core').Object.keys;


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/fn/object/keys.js
// module id = 436
// module chunks = 41